<template>
  <PlantillaContenido>
    <div slot="titulo">Inicio</div>
    <div slot="breadCrumb">
      <nav class="breadcrumb" aria-label="Ubicación actual">
        <ul><li class="is-active"><span aria-current="page">Inicio</span></li></ul>
      </nav>
    </div>
    <div slot="contenido" class="functionary-home">
      <section class="home-hero" aria-labelledby="home-title">
        <div>
          <span class="home-eyebrow">Tu espacio de participación</span>
          <h2 id="home-title">Tus encuestas, en un solo lugar</h2>
          <p>Consulta las encuestas asignadas, revisa cuáles respondiste y participa en las disponibles.</p>
          <router-link class="button home-primary-button" :to="{ name: 'questionary' }">
            Ver mis encuestas <span aria-hidden="true">→</span>
          </router-link>
        </div>
        <div class="home-hero-art" aria-hidden="true">
          <span>✓</span>
          <span>≡</span>
          <span>✓</span>
        </div>
      </section>

      <section aria-labelledby="home-summary-title">
        <div class="home-section-heading">
          <div>
            <span class="home-eyebrow">Resumen</span>
            <h3 id="home-summary-title">Encuestas activas</h3>
          </div>
          <button class="button is-light" type="button" :disabled="loading" @click="loadQuestionaries">Actualizar</button>
        </div>

        <div v-if="loading" class="home-feedback" role="status">Cargando tus encuestas...</div>
        <div v-else-if="error" class="home-feedback home-error" role="alert">
          {{ error }} <button class="button is-small" type="button" @click="loadQuestionaries">Reintentar</button>
        </div>
        <div v-else class="home-summary-grid">
          <router-link class="summary-card" :to="{ name: 'questionary', query: { estado: 'pendientes' } }">
            <span class="summary-icon pending" aria-hidden="true">○</span>
            <strong>{{ pendingCount }}</strong>
            <span>Pendientes</span>
            <small>Encuestas activas que puedes responder</small>
          </router-link>
          <router-link class="summary-card" :to="{ name: 'questionary', query: { estado: 'respondidas' } }">
            <span class="summary-icon answered" aria-hidden="true">✓</span>
            <strong>{{ answeredCount }}</strong>
            <span>Respondidas</span>
            <small>Dentro de las encuestas activas</small>
          </router-link>
          <div class="summary-card summary-total">
            <span class="summary-icon total" aria-hidden="true">≡</span>
            <strong>{{ questionaries.length }}</strong>
            <span>Visibles</span>
            <small>Encuestas activas asignadas</small>
          </div>
        </div>
      </section>
    </div>
  </PlantillaContenido>
</template>

<script>
import PlantillaContenido from "../../template/PlantillaContenido";
import { getFunctionaryQuestionaries, hasAnsweredQuestionary } from "../../services/functionaryQuestionaries";

export default {
  name: "FunctionaryHome",
  components: { PlantillaContenido },
  data() {
    return { questionaries: [], loading: false, error: "" };
  },
  computed: {
    answeredCount() {
      return this.questionaries.filter(hasAnsweredQuestionary).length;
    },
    pendingCount() {
      return this.questionaries.filter(item => item.questionary && item.questionary.state === "Abierta" && !hasAnsweredQuestionary(item)).length;
    },
  },
  mounted() {
    this.loadQuestionaries();
  },
  methods: {
    async loadQuestionaries() {
      this.loading = true;
      this.error = "";
      try {
        this.questionaries = await getFunctionaryQuestionaries(this.$http);
      } catch (error) {
        this.error = "No pudimos cargar el resumen de encuestas.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.functionary-home { display: grid; gap: 2rem; }
.home-hero { display: flex; align-items: center; justify-content: space-between; gap: 2rem; padding: clamp(1.7rem, 4vw, 3rem); border-radius: 18px; background: linear-gradient(120deg, #174d58, #087b72); color: white; overflow: hidden; }
.home-hero > div:first-child { max-width: 36rem; position: relative; z-index: 1; }
.home-eyebrow { color: #1a7774; font-size: .77rem; font-weight: 800; letter-spacing: .11em; text-transform: uppercase; }
.home-hero .home-eyebrow { color: #b5eee0; }
.home-hero h2 { margin: .65rem 0; color: white; font-size: clamp(1.8rem, 3vw, 2.6rem); font-weight: 700; line-height: 1.2; }
.home-hero p { max-width: 31rem; color: #e1f5f0; line-height: 1.6; }
.home-primary-button { display: inline-flex; align-items: center; gap: 1rem; margin-top: 1.5rem; border: 0; border-radius: 9px; background: white; color: #176261; font-weight: 700; }
.home-primary-button:hover, .home-primary-button:focus { background: #e7f7f1; color: #124d4b; }
.home-hero-art { display: grid; grid-template-columns: repeat(2, 4.5rem); gap: .8rem; transform: rotate(-12deg); opacity: .8; }
.home-hero-art span { display: grid; place-items: center; width: 4.5rem; height: 4.5rem; border: 1px solid rgba(255,255,255,.4); border-radius: 15px; background: rgba(255,255,255,.14); font-size: 2rem; }
.home-hero-art span:nth-child(2) { transform: translateY(2rem); }
.home-section-heading { display: flex; align-items: end; justify-content: space-between; gap: 1rem; margin-bottom: 1rem; }
.home-section-heading h3 { color: #24444b; font-size: 1.4rem; font-weight: 700; }
.home-summary-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 1rem; }
.summary-card { display: flex; flex-direction: column; min-height: 175px; padding: 1.3rem; border: 1px solid #e1ebea; border-radius: 14px; background: white; color: #2a4950; box-shadow: 0 8px 20px rgba(30, 69, 70, .04); }
a.summary-card:hover, a.summary-card:focus { border-color: #80beb1; color: #2a4950; box-shadow: 0 10px 25px rgba(30, 69, 70, .1); }
.summary-icon { display: grid; place-items: center; width: 2.3rem; height: 2.3rem; margin-bottom: .8rem; border-radius: 9px; font-size: 1.35rem; }
.summary-icon.pending { background: #e8f4ee; color: #18805c; }
.summary-icon.answered { background: #e5f1f5; color: #26758a; }
.summary-icon.total { background: #f1edfa; color: #6f62a8; }
.summary-card strong { color: #24444b; font-size: 1.9rem; line-height: 1; }
.summary-card > span:not(.summary-icon) { margin-top: .35rem; font-weight: 700; }
.summary-card small { margin-top: .2rem; color: #6a7c80; }
.home-feedback { padding: 1.5rem; border-radius: 12px; background: white; color: #5d7377; }
.home-error { display: flex; align-items: center; justify-content: space-between; gap: 1rem; color: #a13d36; }
@media (max-width: 700px) {
  .home-hero-art { display: none; }
  .home-summary-grid { grid-template-columns: 1fr; }
  .summary-card { min-height: 0; }
}
</style>
